module.exports = __webpack_public_path__ + "static/media/inochicare.dacb1896.webp";